import { motion } from 'framer-motion';
import { ArrowUpRight, ArrowDownRight, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

interface Props {
  change: number;
  loading: boolean;
}

const DailyChangeWidget = ({ change, loading }: Props) => {
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-10">
        <div className="animate-pulse h-4 bg-gray-200 rounded w-48"></div>
      </div>
    );
  }

  const isPositive = change >= 0;
  const changePercentage = (change * 100).toFixed(3);

  const containerVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="flex items-center justify-center space-x-2 bg-white/60 backdrop-blur-sm p-3 rounded-full shadow-inner border border-gray-200"
    >
      {isPositive ? (
        <ArrowUpRight className="w-5 h-5 text-green-500" />
      ) : (
        <ArrowDownRight className="w-5 h-5 text-red-500" />
      )}
      <p className="font-medium text-gray-800">
        {t('home.past24Hours')}
        <span className={`mx-1.5 font-bold ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
          {isPositive ? '+' : ''}{changePercentage}%
        </span>
      </p>
      <TrendingUp className="w-4 h-4 text-gray-500" />
    </motion.div>
  );
};

export default DailyChangeWidget; 